import { useReveal } from "../hooks/use-reveal";
import { useSeo } from "../hooks/use-seo";
import { localBusinessJsonLd, SITE_BASE_URL } from "../lib/jsonld";
import { ContactForm } from "../components/sections/ContactForm";
import { COMPANY } from "../data/site";

export default function Contact() {
    useReveal();
    useSeo({
        title: "Contact HAZ Insulation | Free Quote · Chicagoland & NW Indiana",
        description: `Request a free insulation quote from HAZ Insulation. Call ${COMPANY.phone} or use the form — most jobs inspected and quoted within 48 hours.`,
        canonical: `${SITE_BASE_URL}/contact`,
        jsonLd: localBusinessJsonLd({ url: `${SITE_BASE_URL}/contact`, withRating: true }),
    });

    return (
        <main data-testid="contact-page" className="pt-24">
            <section className="py-20 md:py-28 bg-ink text-bone">
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <div className="text-xs tracking-[0.22em] uppercase font-bold text-ember mb-5 reveal">
                        <span className="h-px w-10 bg-ember inline-block align-middle mr-3" />
                        Contact
                    </div>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-extrabold leading-[0.98] tracking-tight max-w-4xl reveal">
                        Get a free quote in <span className="text-ember">48 hours.</span>
                    </h1>
                    <p className="mt-6 text-lg md:text-xl text-bone/85 max-w-2xl reveal">
                        Most homeowners get a real, scoped quote within two business days — no
                        ballpark guesses, no high-pressure sales calls.
                    </p>
                </div>
            </section>
            <ContactForm />
        </main>
    );
}
